const user = require('./user-service')
const appointments = require('./appointment-service')
const consultations = require('./consultation-service')
const fileDomain = require('./file-service')
const otp = require('./otp-service')
const helpers = require('./helpers')
const marketplace = require('./marketplace')
const alerts = require('./alert-service')
const kyc = require('./kyc-service')
const prescriptions = require('./prescription-service')
const hospital = require('./hospital-service')
const group = require('./group-service')
const ratingDomain = require('./rating-service')
const partner = require('./partner-service')
const icd = require('./icd-service')
const specification = require('./specification-service')
const chat = require('./chat-service')
const plan = require('./plan-service')
const couponDomain = require('./coupon-service')
const setting = require('./setting-service')
const shorturl = require('./shorturl-service')
const trustgate = require('./trustgate-service')

module.exports = {
  helpers,
  user,
  appointments,
  consultations,
  fileDomain,
  otp,
  alerts,
  marketplace,
  kyc,
  prescriptions,
  hospital,
  group,
  ratingDomain,
  partner,
  icd,
  specification,
  chat,
  plan,
  couponDomain,
  setting,
  shorturl,
  trustgate,
}
